import React from 'react';
import { motion } from 'framer-motion';
import { PagesPill } from './PagesPill';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-234" data-mp="3uwgmeb4qdome">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="cn7oelrd1vv4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-236" data-mp="7pem43t6hm04">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-237" data-mp="7pxtiql7crzw">
            6 Core Teaching Volumes for the Art Year
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-238" data-mp="3c4611v64e9c1">
            A connected sequence of visual resources that moves from foundational concepts to
            drawing, color, design, visual culture and independent creative work.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-2" data-id="element-239" data-mp="3l2hndkzyekyo">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-gold/35 bg-navy-mid p-5 shadow-sm shadow-black/25 sm:gap-6 sm:p-7" data-id="element-240" data-mp="2sfn8d3lwodsl" data-mpi={index}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-241" data-mp="2o3ln49uhjtx9">
                <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-242" data-mp="1qho84mfbe6q2">
                  {volume.number}
                </span>
                <PagesPill pages={volume.pages} className="mt-2" data-id="element-243" data-mp="20etwvo0ghln4" />
                <h3 className="mt-3 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-244" data-mp="20diu9riqyjxl">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-245" data-mp="3bu92than7nud">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-gold" data-id="element-246" data-mp="3ftzrnfglztw9">
                  {volume.tag}
                </span>
              </div>
              <img src={volume.coverImage} alt={`Cover of volume ${volume.number}: ${volume.title}`} width="720" height="900" loading="lazy" decoding="async" className="block h-auto w-[96px] shrink-0 self-start object-contain sm:w-[120px]" data-id="element-247" data-mp="1bqy78v92fgfg" />
            </motion.article>)}
        </div>
      </div>
    </section>;
}